import React from "react";
import "./MemberStatusChanger.css";
import MemberStatusButton from "./MemberStatusButton/MemberStatusButton";
import popupicon from "../../../assets/icons/popupicon.svg";
import { UserAuth } from "../../../context/AuthContext";
import strings from "../../../locales/ro.json"
import StandardPopup from "../../Global/StandardPopup/StandardPopup";
import requestHandler from "../../../utils/requestHandler";

/*

  This component is the pressable button to change a member's status. It opens up three identical buttons in a container when pressed in order to change status

  Props

  status : a member's status {"junior","senior","alumni"}. Default is !Error!

*/

function MemberStatusChanger({ status, name , userUid}) {
  const [memberStatus, setMemberStatus] = React.useState(status); // we initialise this to the member status. this is using state so we can see it change without refreshing the page
  const [isChanging, setIsChanging] = React.useState(false); // this is so we open the other three buttons
  const [popupOpen, setPopupOpen] = React.useState(false);
  const [popupFunction, setPopupFunction] = React.useState(() => {});
  const [nextStatute, setNextStatute] = React.useState("Something has gone wrong!"); // this is used when changing status, so we can show it in the popup
  const {user} = UserAuth();


  // this closes the small popup when we click outside of it
  const handleClickOutsideMemberStatus = (event) => {
    if (!event.target.closest('.memberStatusButtonContainer')) {
      setIsChanging((prevIsChanging) => false);
    }
  };

  function toggleChanging() {
    setIsChanging((prevIsChanging) => !prevIsChanging);
  }
  const myAuthToken = `Bearer ${user.accessToken}`

  //send request to backend
  async function setStatuteInBackend(newStatute) {
    try {
      const result = await requestHandler(`users/${userUid}`,"GET",myAuthToken)
      let changed = false;
      result.groups.forEach((element, index) => {
        if(element == strings.basicUserGroups.juniors || element == strings.basicUserGroups.seniors || element == strings.basicUserGroups.alumni || element == strings.basicUserGroups.friends) {
          result.groups[index] = newStatute
          changed = true;
        }
      });

      if(!changed) {
        result.groups.push(newStatute)
      }
      let groups = result.groups
      await requestHandler(`users/${userUid}`,"PATCH",myAuthToken,{groups})
    } catch (error) {
      console.log(error);
    }
  }

  // for popup
  let option = `${name} ${status} -> ${nextStatute} `

  // this is for sorting by statute
  React.useEffect(() => { 
    setMemberStatus(status);
  }, [status]);

  // to unload on lose focus
  React.useEffect(() => {
      document.body.addEventListener('click', handleClickOutsideMemberStatus);
      return () => {
          document.removeEventListener('click', handleClickOutsideMemberStatus, true);
      };
  }, []);

  return (
    <div>
      <StandardPopup isOpen={popupOpen} icon={popupicon} message={strings.usermanagement.changePopup} message2={option} yesFcn={popupFunction} noFcn={() => {setIsChanging(false);setPopupOpen(false)}}/>
      <div className="memberStatusButtonContainer">
        <MemberStatusButton
          status={memberStatus}
          onClickFunction={toggleChanging}
          isAdmin={user.isAdmin}
        />
        {user.isAdmin && isChanging && (
          <div className="memberStatusButtonChangeContainer" data-testid='memberStatusButtonsContainer'>
            <MemberStatusButton
              status={"junior"}
              onClickFunction={() => {
                setPopupFunction((prevfcn) => {
                  return () => {
                    setMemberStatus("junior");
                    setStatuteInBackend(strings.basicUserGroups.juniors);
                    setIsChanging(false);
                    setPopupOpen(false);
                  };
                });
                setNextStatute("junior");
                setPopupOpen(true);
                
              }}
            />
            <MemberStatusButton
              status={"senior"}
              onClickFunction={() => {
                setPopupFunction((prevfcn) => {
                  return () => {
                    setMemberStatus("senior");
                    setStatuteInBackend(strings.basicUserGroups.seniors);
                    setIsChanging(false);
                    setPopupOpen(false);
                  };
                });
                setNextStatute("senior");
                setPopupOpen(true);
              }}
            />
            <MemberStatusButton
              status={"alumni"}
              onClickFunction={() => {
                setPopupFunction((prevfcn) => {
                  return () => {
                    setMemberStatus("alumni");
                    setStatuteInBackend(strings.basicUserGroups.alumni);
                    setIsChanging(false);
                    setPopupOpen(false);
                  };
                });
                setNextStatute("alumni");
                setPopupOpen(true);
              }}
            />
            <MemberStatusButton
              status={"friend"}
              onClickFunction={() => {
                setPopupFunction((prevfcn) => {
                  return () => {
                    setMemberStatus("friend");
                    setStatuteInBackend(strings.basicUserGroups.friends);
                    setIsChanging(false);
                    setPopupOpen(false);
                  };
                });
                setNextStatute("friend");
                setPopupOpen(true);
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default MemberStatusChanger;
